import { Component, ChangeDetectorRef, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-repository',
  templateUrl: './repository.component.html',
  styleUrls: ['./repository.component.css']
})
export class RepositoryComponent {
    window:any=<any>window;
    notification:any = new this.window.HPNotification();
    rand = (num:any = null) => {
        num = num || 12;
        var text = "";
        var characters = "_ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < num; i++) {
            text += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return text;
    };
    openModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(`${selector}`).children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'block');
    };
    closeModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(`${selector}`)?.children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'none');
    };
    queryparams:any = () => this.route.snapshot.queryParams;
    params:any = () => this.route.snapshot.params;
    changeQueryParam:any = (values:any = {}) => new Object({ ...this.route.snapshot.queryParams, ...values });
    updateView:any = () => {
        this.zone.run(() => {
            if(!this.queryparams()['type'] || !this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#documentModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteDocumentModal', element: this.elementref.nativeElement }});
                this.initModel();
            }
            if(this.queryparams()['type'] == 'delete' && !!this.queryparams()['document'] && !!this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#documentModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#deleteDocumentModal', element: this.elementref.nativeElement }});
            }
            if(this.queryparams()['type'] == 'create' && !this.queryparams()['document'] && !!this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteDocumentModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#documentModal', element: this.elementref.nativeElement }});
            }
            if(this.queryparams()['type'] == 'update' && !!this.queryparams()['document'] && !!this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteDocumentModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#documentModal', element: this.elementref.nativeElement }});
            }

            this.updateArchivio();
            this.cdr.detectChanges();
        });
    };
    filter_expanded = false;
    filter:any = new Proxy({
        text: "",
        ordinamento: "", // size_crescente - size_decrescente - time_crescente - time_decrescente
        from: 0,
        to: 0,
        inviati: true,
        ricevuti: true,
        avviso: true,
        messaggio: true,
        altro: true,
        show_clients: true,
        show_workers: true,
        show_mine: true,
        group: "",
        client: "",
        worker: "",
        ...Object.keys(this.window.flowup.utils.collectionFileType).reduce((a, b) => {
            a = a || {};
            a[b] = true;
            return a;
        }, {})
    }, {
        set: (t, p, v) => {
            t[p] = v;
            this.updateArchivio();
            return true;
        }
    });
    datepicker_filter_from:any;
    datepicker_filter_to:any;
    archivio:any = [];
    model_document:any = {
        name: "",
        filename: "",
        display_name: "",
        size: 0,
        upload_timestamp: 0,
        owner: "",
        target: "",
    };
    temp_documents:any = [];
    constructor(
        private cdr: ChangeDetectorRef,
        private route:ActivatedRoute,
        private router:Router,
        private elementref: ElementRef,
        private zone: NgZone
    ) {
        this.cdr.detach();
    }

    ngAfterContentInit() {
        this.route.queryParams.subscribe((p:any) => this.updateView());

        this.window.document.addEventListener('flowup_update', this.updateView.bind(this));
        this.window.usher.element.addEventListener('change', this.updateView.bind(this));
        this.window.emitter.element.addEventListener('change', this.updateView.bind(this));
        this.window.coffe.element.addEventListener('change', this.updateView.bind(this));
        this.window.usher.element.addEventListener("pushMessage", this.pushMessageHandler.bind(this));

        this.datepicker_filter_from = new this.window.HPDatepicker({
            parent: this.elementref.nativeElement,
            allow_empty: true,
            callback: (date) => {
                if(!date) return this.filter.from = 0;
                this.filter.from = date.getTime();
                this.updateArchivio();
            }
        });
        this.datepicker_filter_to = new this.window.HPDatepicker({
            parent: this.elementref.nativeElement,
            allow_empty: true,
            callback: (date) => {
                if(!date) return this.filter.to = 0;
                this.filter.to = date.getTime();
                this.updateArchivio();
            }
        });
    };

    ngOnDestroy() {
        this.window.document.removeEventListener('flowup_update', this.updateView.bind(this));
        this.window.usher.element.removeEventListener('change', this.updateView.bind(this));
        this.window.emitter.element.removeEventListener('change', this.updateView.bind(this));
        this.window.coffe.element.removeEventListener('change', this.updateView.bind(this));
        this.window.usher.element.removeEventListener("pushMessage", this.pushMessageHandler.bind(this));
    };

    pushMessageHandler = (ev:any) => {
        if(ev?.detail?.message == 'update_archivio') return this.updateArchivio();
        return;
    };

    get = (name:any = undefined) => this.archivio.filter(e => !name || e.name == name) || [];

    getUsers = (pt:any = false, type:any = false) => [...this.window.usher.getChildren(), this.window.usher.get()]?.filter(user => (!pt || user.public_token == pt) && (!type || user.public_configuration?.type == type)) || [];

    getDocument = () => {
        if(!!this.queryparams()['document'] && this.queryparams()['type'] != 'create') return this.get(this.queryparams()['document'])[0] || this.model_document;
        return this.model_document;
    };

    initModel = () => {
        this.temp_documents.length = 0;
        this.model_document = {
            name: "",
            filename: "",
            display_name: "",
            size: 0,
            upload_timestamp: 0,
            owner: "",
            target: "",
            type: ""
        };
    };

    handleModal = (document:any = undefined, type:any = undefined) => {
        this.router.navigate([`/repository`], { queryParams: this.changeQueryParam({ "document" : document, "type" : type }) });
    };

    getArchivio = () => {
        let date = this.window.moment().format("DD_MM_YYYY-HH:mm"),
            documents_avvisi = this.window.emitter.getEvents()?.filter(el => el.configuration.type == 'comunicazione')?.map(e => e.configuration.allegati)?.flat() || [],
            documents_chat = Object.values(this.window.coffe.getRecipients())?.map((e:any) => e.messages)?.flat()?.filter(e => !!e?.media_url)?.map(e => new Object({
                filename: e.media_url,
                display_name: `Messaggio_${date}`,
                name: e.media_url,
                owner: e.public_token_owner,
                upload_timestamp: (new Date(e.creation_timestamp)).getTime(),
                filetype: this.window.flowup.utils.getFileType(e.media_url),
                mime: e.type,
                size: 0
            })) || [],
            documents_archivio_users = this.getUsers()?.map(e => e.configuration.archive).flat() || [];

        return [...documents_avvisi, ...documents_chat, ...documents_archivio_users].filter(e => !!e?.name && !!e?.upload_timestamp).sort((a, b) => {
            return a.upload_timestamp > b.upload_timestamp ? -1 : a.upload_timestamp == b.upload_timestamp ? 0 : 1;
        })
        .filter(e => !this.filter.text || e.name?.toLowerCase().includes(this.filter.text.toLowerCase()) || e.display?.toLowerCase().includes(this.filter.text.toLowerCase()) || e.filename?.toLowerCase().includes(this.filter.text.toLowerCase()))
        .filter(e => {
            if(!this.filter.inviati && e.owner == this.window.usher.getPublicToken()) return false;
            if(!this.filter.ricevuti && e.owner != this.window.usher.getPublicToken()) return false;
            if(!this.filter.altro && !!e.type && e.type == 'archivio') return false;
            if(!this.filter.avviso && !!e.type && e.type == 'avviso') return false;
            if(!this.filter.messaggio && !!e.type && e.type == 'messaggio') return false;
            if(!!this.filter.group && 
                !this.getUsers(e.owner)[0].public_configuration?.groups?.find(e => e.id == this.filter.group)) return false;
            if(!!this.filter.client && 
                e.owner != this.filter.client) return false;
            if(!!this.filter.worker && 
                e.owner != this.filter.worker) return false;
            if(!!this.filter.from &&
                e.upload_timestamp < this.filter.from) return false;
            if(!!this.filter.to &&
                e.upload_timestamp > this.filter.to) return false;
            if(!!e.filetype && !this.filter[e.filetype]) return false;

            if(!this.filter.show_clients && !!this.getUsers(e.owner, 'cliente')[0]?.public_token) return false;
            if(!this.filter.show_workers && !!this.getUsers(e.owner, 'dipendente')[0]?.public_token) return false;
            if(!this.filter.show_mine && e.owner == this.window.usher.getPublicToken()) return false;
            return true;
        })
        .sort((a, b) => {
            if(!this.filter.ordinamento) return 0;
            let type = this.filter.ordinamento.split("_")[0],
                ordinamento = this.filter.ordinamento.split("_")[1];
            
            if(type == 'size') return a.size > b.size ? (ordinamento == 'crescente' ? 1 : -1) : (ordinamento == 'crescente' ? -1 : 1);
            if(type == 'time') return a.upload_timestamp > b.upload_timestamp ? (ordinamento == 'crescente' ? -1 : 1) : (ordinamento == 'crescente' ? 1 : -1);
        });
    };

    updateArchivio = () => {
        this.archivio.length = 0;
        this.archivio.push(...this.getArchivio());
        this.cdr.detectChanges();
    };

    deleteDocument = async () => {
        if(this.getDocument().type != 'archivio') return;
        
        let doc_index = this.window.usher.get().configuration?.archive?.findIndex(e => e.name == this.getDocument().name);
        if(doc_index >= 0) {
            this.window.usher.get().configuration?.archive?.splice(doc_index, 1);
            try {
                await this.window.usher.updateMySelf();
                this.handleModal(undefined,undefined);
            } catch(e) {
                console.log(e);
            }
        }
        return;
    };

    openDocument = (doc:any = {}) => this.window.flowup.signal.emit({name: "open-file", detail: {
        path: this.window.flowup.utils.getMedia(doc.name),
        mime: doc.mime,
        name: doc.name
    }});

    resetFilter = () => {
        this.filter = new Proxy({
            text: "",
            ordinamento: "", // size_crescente - size_decrescente - time_crescente - time_decrescente
            from: "",
            to: "",
            inviati: true,
            ricevuti: true,
            avviso: true,
            messaggio: true,
            altro: true,
            show_clients: true,
            show_workers: true,
            show_mine: true,
            group: "",
            client: "",
            worker: "",
            ...Object.keys(this.window.flowup.utils.collectionFileType).reduce((a, b) => {
                a = a || {};
                a[b] = true;
                return a;
            }, {})
        }, {
            set: (t, p, v) => {
                t[p] = v;
                this.updateArchivio();
                return true;
            }
        });
    };

    getDocuments = async (input:any = undefined) => {
        this.window.flowup.signal.emit({name: 'get-files', detail: {
            event: input,
            callback: (parsed_files) => {
                this.window.flowup.signal.emit({name: 'upload-files', detail: {
                    collection: parsed_files,
                    callback: (sent) => {
                        this.temp_documents.push(...sent.map(s => new Object({
                            ...s,
                            type: 'archivio',
                            target: this.getDocument().target || this.window.usher.getPublicToken(),
                            owner: this.getDocument().target || this.window.usher.getPublicToken()
                        })));
                        this.updateView();
                        return this.notification.success({text: "Documenti caricati con successo."});
                    },
                    error: (file) => {
                        return this.notification.danger({text: `Errore nel caricamento del file ${file.filename}`});
                    }
                }});
            }
        }});
    };

    deleteTempDoc = (i:any) => {
        this.temp_documents.splice(i, 1);
        this.updateView();
    };

    handleDocument = async () => {
        try {
            let target = !!this.getDocument().target ? this.getUsers(this.getDocument().target)[0] : this.window.usher.get();
            target.configuration.archive = target.configuration.archive || [];
            target.configuration.archive.push(...this.temp_documents);
            await target.update();
            this.handleModal(undefined, undefined);
            this.initModel();
            return this.notification.success({text: `Documenti caricati con successo.`});
        } catch(e) {
            console.log(e);
            return this.notification.danger({text: `Errore. Riprova più tardi.`});
        }
    };
}